module.exports = __webpack_public_path__ + "img/helpvouchers.0c4d502b.svg";